import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';

import { withModalActions, withLocale, withUserAgent } from 'core/hocs';
import { FormattedTag, Button } from 'core/components';
import { wrapRoute2Locale } from 'core/helpers';

import { ModalWindow } from 'components/modal-window/modal-window';

import { MODAL_IDS } from '../../../constants';

import './go-to-deposit-modal.scss';

const GoToDepositModalUI = ({ closeModal, locale, isPwa }) => {
  const history = useHistory();

  return (
    <ModalWindow
      isCentered
      id={MODAL_IDS.GO_TO_DEPOSIT}
      coreProps={{ id: MODAL_IDS.GO_TO_DEPOSIT }}
      className="go-to-deposit-modal"
      bodyClassName="d-flex d-sm-block align-items-center flex-column justify-content-sm-center text-center"
      fade
    >
      <img
        src="/assets/public/images/depos-money.png"
        className="mb-2 depos-money"
        alt="Deposit money"
      />
      <FormattedTag
        tag="div"
        id="got-to-deposit.title"
        className="h2 text-center mb-1"
      />
      <FormattedTag
        tag="div"
        id="got-to-deposit.text"
        className=" mb-3 text-gray-20 text-center"
      />
      <FormattedTag
        id="got-to-deposit.button"
        tag={Button}
        type="primary"
        className="w-100 btn btn-primary btn-lg"

        // eslint-disable-next-line react/jsx-no-bind
        onClick={() => {
          closeModal(MODAL_IDS.GO_TO_DEPOSIT);
          history.push(wrapRoute2Locale(`/wallet${isPwa ? '?launch_from=pwa' : ''}`, locale));
        }}
      />
    </ModalWindow>
  );
};

GoToDepositModalUI.propTypes = {
  closeModal: PropTypes.func.isRequired,
  locale: PropTypes.string.isRequired,
  isPwa: PropTypes.bool.isRequired,
};

export const GoToDepositModal = withUserAgent(withLocale(withModalActions(GoToDepositModalUI)));
